import styled from 'styled-components';

export const OrgIcon = styled.img`
  width: 30px;
  flex: 0 0 auto;
  display: inline-block;
  border-radius: 3px;
  margin: 0 15px 0 2px;
`;
